// The logged-out agent-chat entry state: a calm full-panel prompt to sign in
// before building an agent. Rebuilt on the design-system Empty composition
// (W-24314366), replacing the retired tds2_shim/agentforce/UnauthenticatedState.
// The login CTA is a plain <a> styled as a primary button via `buttonVariants`
// (an anchor, not a <button>, so it navigates). Panel-specific layout lives in
// `.tds2-agent-entry-state` in _agent_chat.scss.
import React from 'react';
import PropTypes from 'prop-types';
import { Empty, EmptyHeader, EmptyMedia, EmptyTitle, EmptyDescription, EmptyContent, buttonVariants } from '@trailhead-emu/design-system';
import BetaTag from 'components/agentforce/BetaTag';

export default function UnauthenticatedState({
  mascotUrl,
  title = 'Log in or sign up to start building...',
  body = 'Please log in to start creating your agent.',
  loginUrl = '/login',
  loginLabel = 'Log in to Trailhead',
}) {
  return (
    <Empty
      variant="flush"
      className="tds2-agent-entry-state"
      role="status"
      aria-live="polite"
    >
      <EmptyHeader>
        {mascotUrl ? (
          <EmptyMedia variant="img">
            <img src={mascotUrl} alt="" aria-hidden="true" />
          </EmptyMedia>
        ) : null}
        <BetaTag />
        <EmptyTitle>{title}</EmptyTitle>
        <EmptyDescription>{body}</EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <a href={loginUrl} className={buttonVariants({ variant: 'primary', size: 'small' })}>
          {loginLabel}
        </a>
      </EmptyContent>
    </Empty>
  );
}

UnauthenticatedState.propTypes = {
  mascotUrl: PropTypes.string,
  title: PropTypes.string,
  body: PropTypes.string,
  loginUrl: PropTypes.string,
  loginLabel: PropTypes.string,
};
